import { render, staticRenderFns } from "./UserApplications.vue?vue&type=template&id=4ae6b456&"
import script from "./UserApplications.vue?vue&type=script&lang=ts&"
export * from "./UserApplications.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports